import * as actionTypes from '../../types/general';
import { switchViewModeUrl } from '../../../services/endpoints/general';

/**
 * @function
 * @name switchViewMode
 * @description Смена цветовой темы
 * @param {number} value
 */
export const switchViewMode = (value) => async (dispatch) => {
  dispatch({ type: actionTypes.CHANGE_VIEW_MODE });

  try {
    const response = await switchViewModeUrl(value);
    const { data } = response;
    const { dark_mode } = data;

    dispatch({
      type: actionTypes.CHANGE_VIEW_MODE_SUCCESS,
      payload: dark_mode,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.CHANGE_VIEW_MODE_ERROR,
      error,
    });
  }
};

export const toggleFixedAlert = (showAlert, path) => (dispatch) => {
  dispatch({
    type: actionTypes.TOGGLE_FIXED_ALERT,
    showAlert,
    path,
  });
};

export const toggleGuidesPortal = (value, data) => (dispatch) => {
  dispatch({
    type: actionTypes.TOGGLE_GUIDES_PORTAL,
    value,
    data,
  });
};
